import { Injectable } from '@angular/core';

import { AgentTopic } from 'src/models';

import { GenericObjectsService } from './generic-objects.service';

@Injectable({
  providedIn: 'root',
})
export class AgentTopicsService extends GenericObjectsService<AgentTopic> {
  protected baseUrl = '/agent-topics';
}
